import {
   rand,
   randNumber,
   randWord,
   randAirportCode,
   randPastDate,
   randSoonDate,
   randParagraph,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { Milestones, Shipment } from '../shipment';
import { BillingParties } from '../base';

import { MockAttachment } from './attachment.mock';
import { MockBillingParty } from './billing-party.mock';
import { MockCalculator } from './calculator.mock';
import { MockCOD } from './cod.mock';
import { MockHawb } from './hawb.mock';
import { MockPOD } from './pod.mock';
import { MockReference } from './reference.mock';
import { MockRisks } from './risks.mock';
import { MockStatus } from './status.mock';
import { MockTradeshow } from './tradeshow.mock';

export class MockShipment extends Shipment<any, any> {
   constructor() {
      super();

      this.hawb = MockHawb();

      this.station = new MockBillingParty();

      this.billingparty = rand([ ...BillingParties ]);
      this.shipper = new MockBillingParty();
      this.consignee = new MockBillingParty();
      this.bill_to = new MockBillingParty();

      this.servicelevel = randWord({ length: 2, capitalize: true }).join( ' ' );

      if ( optional() ) { this.airportfrom = randAirportCode(); }
      if ( optional() ) { this.airportto = randAirportCode(); }

      [
         [ this.pdatefrom, this.ptimefrom ],
         [ this.pdateto, this.ptimeto ],
         [ this.ddatefrom, this.dtimefrom ],
         [ this.ddateto, this.dtimeto ],
      ] = randSoonDate({ length: 4, days: 4 }).map( d => d.toISOString().slice( 0, -8 )).sort().map( d => d.split( 'T' ));

      this.calculator = Array.from({ length: randNumber({ max: 10 }) }, _ => new MockCalculator() );

      if ( optional() ) { this.references = Array.from({ length: randNumber({ max: 10 }) }, _ => new MockReference() ); }

      if ( optional() ) { this.tradeshow = [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ]; }

      if ( optional() ) { this.risks = new MockRisks(); }

      // if ( optional() ) { this.statuses = Array.from({ length: randNumber({ max: 5 }) }, _ => new MockStatus() ); }
      this.statuses = Array.from({ length: randNumber({ min: 1, max: 5 }) }, _ => new MockStatus() );

      if ( optional() ) { this.cod = new MockCOD(); }

      if ( optional() ) { this.pod = new MockPOD(); }

      this.milestones = Milestones( this.mode );
      const length = randNumber({ max: Object.keys( this.milestones ).length });
      Object.keys( this.milestones ).map(( key, index ) => {
         if ( index < length && optional() ) {
            this.milestones[key] = randPastDate();
         }
      });

      if ( optional() ) { this.description = randParagraph(); }
      if ( optional() ) { this.specialinstructions = randParagraph(); }

      if ( optional() ) {
         this.attachments = Array.from({ length: randNumber({ max: 5 }) }, _ => new MockAttachment() );
      }

      this.itemsType = rand([ 'LCL', 'FCL' ]);
   }
}
